/**
 * Curated quick-pick swatches for a symbol/type color picker: a base curated set plus any colors already
 * in use by presets, so opening any preset shows its current color already offered. Not exhaustive — pickers
 * built on this also offer a native color input for any other color. Case-insensitively deduped.
 */
export function buildColorPalette(curated: readonly string[], extra: readonly string[]): string[] {
	const palette: string[] = [];
	const seen = new Set<string>();
	for (const color of [...curated, ...extra]) {
		const key = color.toLowerCase();
		if (!seen.has(key)) {
			seen.add(key);
			palette.push(color);
		}
	}
	return palette;
}
